<template>
  <div class="min-h-[100vh] pb-[80] bg-[#f7f7f9]">
    <dg-head> </dg-head>
    <div v-if="detail.status != 1000" class="w-[1024] mx-[auto] mt-[12] bg-[#fff] rounded-[4] content pt-[36] pb-[30] pl-[16] pr-[16]">
      <p class="t-[#000000] t-[18] text-center">{{ detail.title }}</p>
      <p class="t-[#909399] t-[14] text-center pt-[10] pb-[26]">发布时间：{{ detail.gmtCreate }}</p>

      <div class="w-[853] mx-[auto]" v-html="detail.content"></div>
    </div>
    <div v-else class="noData pt-[20vh] text-center">
      <p><img width="300px" src="../../assets/img/null.jpg" alt="" /></p>
      <p class="t-[#A1A3A6] t-16">不好意思，该公告已删除</p>
    </div>
    <div class="pt-[20]">
      <dg-copyright></dg-copyright>
    </div>

  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  data() {
    return {
      detail: {},
    };
  },
  methods: {},
  mounted() {},
  created() {
    ajax.post({
      url: "/supplyChain/accountInformation/announce",
      data: {},
      success: (res) => {
        if (res) {
          this.detail = res || {};
        }
      },
      fail: () => {},
    });

    // ajax.post({
    //   url: "/customer/message/platformAnnounceDetail",
    //   data: { id: this.query.id },
    //   success: (res) => {
    //     this.$root.$emit("unreadMessageCount", "");
    //     this.$root.$emit("getAnnounce", "");
    //     if (res.status == 1000) {
    //       this.detail;
    //     }

    //     this.detail = res || {};
    //   },
    //   fail: () => {},
    // });
  },
};
</script>
<style lang="less" scoped>
@import '~@/assets/css/var.less';
.head {
  background: #fff;
  padding: 16px 0;
  box-shadow: 0px 3px 6px 0px rgba(197, 197, 197, 0.14);

  .logo {
    width: 450px;
  }
}

.content {
  box-shadow: 0px 1px 5px 0px rgba(197, 197, 197, 0.14);
  min-height: 615px;

  .bor-bottom {
    position: relative;
    &::after {
      content: "";
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: #e4e4e4;
      transform: scale(1, 0.5);
    }
  }
}
</style>
 <style>.min-h-\[100vh\] {
    min-height: 100vh
}
.pb-\[80\] {
    padding-bottom: 80px
}
.bg-\[\#f7f7f9\] {
    background-color: #f7f7f9
}
.w-\[1024\] {
    width: 1024px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}
.mt-\[12\] {
    margin-top: 12px
}
.bg-\[\#fff\] {
    background-color: #fff
}
.rounded-\[4\] {
    border-radius: 4px
}
.pt-\[36\] {
    padding-top: 36px
}
.pb-\[30\] {
    padding-bottom: 30px
}
.pl-\[16\] {
    padding-left: 16px
}
.pr-\[16\] {
    padding-right: 16px
}
.t-\[\#000000\] {
    color: #000000
}
.t-\[18\] {
    font-size: 18px
}
.t-\[\#909399\] {
    color: #909399
}
.t-\[14\] {
    font-size: 14px
}
.pt-\[10\] {
    padding-top: 10px
}
.pb-\[26\] {
    padding-bottom: 26px
}
.w-\[853\] {
    width: 853px
}
.pt-\[20vh\] {
    padding-top: 20vh
}
.t-\[\#A1A3A6\] {
    color: #A1A3A6
}
.pt-\[20\] {
    padding-top: 20px
}
.text-center {
    text-align: center
}</style>